<template>
  <div class="order-detail-content">
    <div class="order-detail-item order-detail-status">
      <div class="order-detail-audit-status">
        <div class="color-black bold">
          订单审核状态：{{ orderDetail.order_info.status_name }}
        </div>
        <div
          v-if="orderDetail.order_info.extra.fail_message"
          class="font-size14"
        >
          失败原因：{{ orderDetail.order_info.extra.fail_message }}
        </div>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        学员信息
      </div>
      <div class="order-detail-student">
        <div class="order-detail-people-name">
          <span
            class="order-detail-student-name"
          >学员姓名： {{ orderDetail.sub_info.sub_name }}</span>
          <span>就读小学：{{ orderDetail.sub_info.school_name }}</span>
          <span>就读年级：{{ orderDetail.sub_info.grade_name }}</span>
        </div>
        <div class="order-detail-people-name">
          <span
            class="order-detail-student-name"
          >家长姓名：{{ orderDetail.master_info.master_name }}</span>
          <span>家长电话：<MobileHidden :params="{sub_id: orderDetail.sub_info.sub_id }" :encrypt="orderDetail.master_info.mobile" /></span>
        </div>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        套餐信息
      </div>
      <div class="order-detail-package">
        <div>套餐名称：{{ orderDetail.item_title }}</div>
        <div>课时信息：</div>
        <el-table :data="orderDetail.sku_set">
          <el-table-column prop="summary" label="类型" />
          <el-table-column prop="days" label="订单课时（天）" />
        </el-table>
      </div>
      <div v-if="orderDetail.combine_list && orderDetail.combine_list.length>0" class="order-detail-package" style="margin-top:10px">
        <div>赠送小学生课时</div>
        <div>课时信息：</div>
        <el-table :data="orderDetail.combine_list">
          <el-table-column prop="subject_name" label="科目" />
          <el-table-column prop="course_type_name" label="类型" />
          <el-table-column prop="num" label="课次(天)" />
        </el-table>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        签约信息
      </div>
      <div class="order-detail-package">
        <div>签约单号：{{ orderDetail.order_info.order_id }}</div>
        <div>订单金额：¥{{ orderDetail.order_info.contract_amount / 100 }}</div>
        <!-- <div v-if="orderDetail.order_info.deduction_amount != 0">
          余额抵扣：¥{{ orderDetail.order_info.deduction_amount / 100 }}
        </div> -->
        <!-- <div v-if="orderDetail.order_info.deduction_summary" v-html="orderDetail.order_info.deduction_summary" /> -->
        <div v-for="(item,index) in orderDetail.discounts" :key="`discounts_${index}`">
          {{ item.classify_name }}：￥{{ item.value/100 }}元<span v-if="item.coupon_desc">(备注: {{ item.coupon_desc }})</span>
        </div>
        <div v-if="orderDetail.order_info.selling_billing_method">
          支付方式：{{ orderDetail.order_info.payment_name }}
        </div>
        <div class="color-danger">
          实际支付：¥{{ orderDetail.order_info.actual_amount / 100 }}
        </div>
        <div v-if="orderDetail.order_info.selling_billing_method">
          支付方式：{{ orderDetail.order_info.payment_name }}
        </div>
        <div v-if="orderDetail.order_info.create_time">
          支付时间：{{ orderDetail.order_info.success_time }}
        </div>
        <div v-if="orderDetail.order_info.remark">
          财务单号：{{ orderDetail.order_info.remark }}
        </div>
        <div v-if="orderDetail.order_info.out_trade_no">
          商户订单号：{{ orderDetail.order_info.out_trade_no }}
        </div>
        <div v-if="orderDetail.finance_info && orderDetail.finance_info.payment_document">
          <div>转账凭证：</div>
          <el-image style="width: 300px;" :src="orderDetail.finance_info.payment_document" :preview-src-list="[orderDetail.finance_info.payment_document]" />
        </div>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        责任人信息
      </div>
      <div class="order-detail-sales">
        <div class="order-detail-people-name">
          <span>提交人：{{ orderDetail.order_info.editor_name }}</span>
          <span>销售人: {{ orderDetail.order_info.salesperson_name }}</span>
          <span>班主任：{{ orderDetail.order_info.headmaster_name }}</span>
        </div>
      </div>
    </div>
    <div v-if="type == 'signingAudit'" class="order-audit-btn">
      <div class="order-audit-btn-title">上传支付凭证</div>
      <qiniu-upload ref="'uploadqiniu'" :files="uploadFiles" :up-type="`payment_document/${today}`" :limit="1" :auto-upload="true" @success="uploadSuccess" />

      <el-row type="flex" justify="end">
        <el-input
          v-model="success_remark"
          clearable
          placeholder="请输入财务流水单号"
        />
        <el-button type="primary" @click="auditSuccess">审核成功</el-button>
      </el-row>
      <el-row type="flex" justify="end">
        <el-input
          v-model="fail_remark"
          clearable
          placeholder="请输入失败原因"
        />
        <el-button type="info" @click="auditFail">审核失败</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import MobileHidden from '@/components/MobileHidden'
import qiniuUpload from '@/components/FormBox/QiniuUpload.vue'
var moment = require('moment')

export default {
  name: 'OrderSigningInfo',
  components: {
    MobileHidden,
    qiniuUpload
  },
  filters: {
    orderStatus(val1, val2) {
      if (val1 == '0') {
        return '待校长审核'
      } else if (val1 == '1' && val2 == '6') {
        return '待总部审核'
      } else if (val1 == '1' && val2 != '6') {
        return '待财务审核'
      } else if (val1 == '2') {
        return '审核成功'
      } else if (val1 == '3') {
        return '审核失败'
      }
    },
    payType(val) {
      if (val == 'alipay') {
        return '支付宝'
      } else if (val == 'lkl') {
        return 'POS支付'
      } else if (val == 'turn') {
        return '直接转账'
      } else if (val == 'cash') {
        return '现金支付'
      } else if (val == 'bank') {
        return '银行卡'
      } else if (val == 'wxqr') {
        return '微信'
      }
    }
  },
  props: {
    orderDetail: Object,
    type: String
  },
  data() {
    return {
      success_remark: '',
      fail_remark: '',
      audit_status: '',
      pzFiles: '',
      uploadFiles: [],
      today: moment().format('YYYY-MM')
    }
  },
  methods: {
    uploadSuccess(e) {
      const { urls } = e
      this.pzFiles = urls.join(',')
      console.log('上传成功', this.pzFiles)
    },
    auditSuccess() {
      if (!this.success_remark) {
        this.$message({
          type: 'info',
          message: '请输入财务流水单号'
        })
        return
      }
      // if (!this.pzFiles) {
      //   this.$message({
      //     type: 'info',
      //     message: '请上传支付凭证'
      //   })
      //   return
      // }
      const obj = {
        order_id: this.orderDetail.order_info.order_id,
        remark: this.success_remark,
        audit_status: 'success',
        payment_document: this.pzFiles || ''
      }
      this.$http.auditOrder(obj).then(() => {
        this.$emit('updateOrderList')
      })
    },
    auditFail() {
      if (!this.fail_remark) {
        this.$message({
          type: 'info',
          message: '请填写审核失败原因'
        })
        return
      }
      const obj = {
        order_id: this.orderDetail.order_info.order_id,
        remark: this.fail_remark,
        audit_status: 'fail'
      }
      this.$http.auditOrder(obj).then(res => {
        if (res.code == 200) {
          this.$emit('updateOrderList')
        }
      })
    }
  }
}
</script>

<style lang="scss">
.order-detail-dialog .el-dialog__body {
  height: 700px;
  padding: 20px 30px;
  overflow: auto;
  .order-detail-content {
    line-height: 24px;
    .order-detail-item {
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #f5f5f5;
    }
    .order-detail-status {
      padding: 15px 20px;
      background-color: #f5f5f5;
    }
    .order-detail-item-title {
      margin-bottom: 15px;
    }
    .order-detail-people-name span {
      margin-right: 30px;
    }
    .order-detail-student-name {
      width: 160px;
    }
    .el-table {
      margin-top: 10px;
    }
    .el-table tr th {
      height: 34px !important;
      background: #fff !important;
      color: #333;
    }
    .el-table td,
    .el-table th {
      padding: 4px;
      border: 1px solid #f5f5f5;
    }
  }
  .order-audit-btn {
    .el-row {
      margin-bottom: 10px;
    }
    .el-input {
      margin-right: 20px;
    }
  }
  .special-table {
    width: 100%;
    margin: 30px 0;
    border: 1px solid #f5f5f5;
    tr,
    th,
    td {
      text-align: center;
      padding: 10px 0;
      border: 1px solid #f5f5f5;
    }
  }
}
</style>
